import React from 'react'
import styled from 'styled-components'
import Icon from '../../../application/assets/images/ufarm-x-map.png'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

function CustomMarker({ markerData }) {

    // const markerData = {
    //     responseId: "643d671c3f472269444c0fae",
    //     formId: "643d21024af8563107fbb976",
    //     form:"First Form",
    //     responseDate: "2022-09-20T14:05:00.000Z",
    //     agent: "Toyyib Omolola"
    // };

    const [displayData, setDisplayData] = useState(false)

    return (
        <div className=' w-8 relative' onMouseLeave={() => setDisplayData(false)}>
            <img
                className=" w-full"
                src={Icon} alt="marker"
                onMouseEnter={() => setDisplayData(true)}
            />
            {
                markerData && <div className={` p-2 rounded-md absolute top-0 left-0 bg-white text-md ${displayData ? "block" : "hidden"} `}>

                    <div className=' flex flex-col gap-2'>
                        <Link className=' text-blue-700' to={`/form/responses/${markerData.responseId}`} >Response: {markerData.responseId} </Link>

                        <Link className=' text-blue-700' to={`/form/${markerData.formId}`} >Form: {markerData.form} </Link>

                        <p>Collected: {format(new Date(markerData.responseDate), "PPPp")}</p>
                        <p>Agent: {markerData.agent}</p>
                    </div>


                </div>
            }
        </div>
    )
}

export default CustomMarker